'use strict';

const React = require('react'),
    PropTypes = React.PropTypes,
    buttonFactory = {
        primary(onClick, label, icon, style, className, isDisabled) {
            const classNameValue = `form-group-button form-group-button-primary ${className} ${isDisabled ? ' is-disabled' : ''}`;
            return (
                React.createElement("button", {style: style, onClick:  isDisabled ? () => {} : onClick, 
                        className: classNameValue}, 
                    label 
                ));
        },
        secondary(onClick, label, icon, style, className, isDisabled) {
            const classNameValue = `form-group-button form-group-button-secondary ${className} ${isDisabled ? ' is-disabled' : ''}`;
            return (
                React.createElement("button", {style: style, onClick:  isDisabled ? () => {} : onClick, 
                        className: classNameValue}, 
                    label 
                ));
        },
        icon(onClick, label, icon, style, className, isDisabled) {
            const classNameValue = `form-group-button form-group-button-icon ${className} ${isDisabled ? ' is-disabled' : ''}`;
            return (
                React.createElement("button", {style: style, onClick:  isDisabled ? () => {} : onClick, 
                        className: classNameValue}, 
                    label, 
                    React.createElement("i", {className: "material-icons md-48"}, icon)
                ));
        }
    };


const FormGroupButton = React.createClass({displayName: "FormGroupButton",

    propTypes: {
        type: PropTypes.oneOf(['primary', 'secondary', 'icon']),
        label: PropTypes.string,
        icon: PropTypes.string,
        onClick: PropTypes.func,
        style: PropTypes.object,
        className: PropTypes.string,
        disable: PropTypes.bool
    },

    render() {
        const {onClick, type, label, style, icon, className, disable} = this.props;
        return buttonFactory[type === undefined ? 'primary' : type](onClick, label, icon, style, className, disable);
    }

});

module.exports = FormGroupButton;



/** WEBPACK FOOTER **
 ** ./src/components/Commons/BasicForm/FormGroupButton/FormGroupButton.js
 **/